import MainStyle        from "components/UI/main.module.scss";
import { useNavigate }  from "react-router-dom";
import { GetLabel    }  from "Utilities/utils";

const BtnLoginAvatar = () => {
    const navigate = useNavigate();
    return (
        <>
            <button 
                onClick={() => navigate("/login")}
                className={[MainStyle.btn_menu_user_head, 
                    MainStyle.rounded_1, 
                    MainStyle.border, 
                    MainStyle.shadow_sm,
                    MainStyle.mb_0, 
                    MainStyle.pb_0,
                    MainStyle.mx_1
                  ].join(" ")}
            >
                <div className={[MainStyle.d_flex, MainStyle.py_1].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 448 512"
                        className={MainStyle.btnLoginAvatar}>
                            <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"/>
                    </svg>
                    <span className={[MainStyle.fs_5, MainStyle.mx_2, MainStyle.text_justify].join(" ")}>
                        {GetLabel(null, 10)}
                    </span> 
                </div>
            </button>
        </>
    );
};
export default BtnLoginAvatar;
